const mutationTypes = {
  SET_TEMPLATE: 'SET_TEMPLATE',
  SET_FIELD: 'SET_FIELD',
  CLEAR_TEMPLATES: 'CLEAR_TEMPLATES',
};

const state = {
  templates: {},
  field: {}
};

const mutations = {
  [mutationTypes.SET_TEMPLATE]: (state, action) => {
    state.templates[action.id] = action.template;
  },
  [mutationTypes.SET_FIELD]: (state, action) => {
    state.field = action.field;
  },
  [mutationTypes.CLEAR_TEMPLATES]: (state) => {
    state.templates = {};
    state.field = {};
  }
};

const actions = {
  setTemplate: ({ commit }, action) => {
    commit(mutationTypes.SET_TEMPLATE, action);
  },
  setField: ({ commit }, action) => {
    commit(mutationTypes.SET_FIELD, action);
  },
  clearTemplates: ({ commit }, action) => {
    commit(mutationTypes.CLEAR_TEMPLATES, action);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
